import { yupObject, validation } from 'utils/validation';

export const validationSchema = yupObject({
  logo: validation.pictureFields.logo,
  ...validation.companyAddressFields,
  ...validation.companyGeneralFields,
  ...validation.selectOptionsBuyer,
  ...validation.socialMediaFields,
});
